(function () {
    const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

    const normalizarURL = url =>
    (url || '')
        .split('?')[0]
        .replace(/_\d+x[^/]*?\.(jpe?g|png|webp)$/i, '.$1') 
        .split('/').pop(); 

    const srcMiniatura = thumb => {
    const img = thumb.querySelector('img');
    if (!img) return '';
    const candidato =
        img.currentSrc ||
        img.src ||
        (img.getAttribute('data-srcset') || '').split(' ')[0] ||
        img.getAttribute('data-src') ||
        '';
    return normalizarURL(candidato);
    };

    const cssThumb = '.product-thumbnail.hide-image{display:none!important;}',
          cssSlide = '.product-images__slide.hide-slide{display:none!important;}';

    [ ['css-thumb', cssThumb], ['css-slide', cssSlide] ].forEach(([id, css]) => {
        if (!document.getElementById(id)) {
            const s = document.createElement('style');
            s.id = id;
            s.textContent = css;
            document.head.appendChild(s);
        }
    });

    let patronesCache = null, filtrando = false, reorganizando = false;
    let mutationObserver = null;
    let resizeListener = null;
    let navClickListeners = new Map();
    let reorganizarSlidesFn = null;

    async function reordenarThumbsSegunProducto() {
    const cont = document.getElementById('Product-Thumbnails');
    if (!cont) return;

    const urlJson = `${location.origin}${location.pathname}.js`;
    const res     = await fetch(urlJson, { cache: 'no-store' });
    if (!res.ok)  return;

    const product     = await res.json();
    const ordenImagen = product.images.map(normalizarURL);

    const big   = Number.MAX_SAFE_INTEGER;
    const idxOf = t => {
        const i = ordenImagen.indexOf(srcMiniatura(t));
        return i === -1 ? big : i;
    };

    [...cont.children]
        .sort((a, b) => idxOf(a) - idxOf(b))
        .forEach(t => cont.appendChild(t));

    patronesCache = null; 
    }


    /* ─── AGRUPACIÓN ADAPTATIVA POR VARIANTE ───────────────── */
    const obtenerDigitos = id => (id.match(/-(\d+)$/) || [,''])[1];

    function longitudPrefijoIdeal() {
        const thumbs    = $$('#Product-Thumbnails .product-thumbnail');
        const variantes = thumbs.filter(t =>
            t.classList.contains('product-images__slide-item--variant')
        );
        if (!variantes.length) return 5;

        const digVar = variantes.map(t => obtenerDigitos(t.id));
        const total  = digVar.length;

        for (let len = 5; len <= 12; len++) {
            const set = new Set(digVar.map(d => d.slice(0, len)));
            if (set.size === total) return len;
        }
        return 8
    }

    /* Devuelve el prefijo que identifica la variante */
    const extraerPatron = (() => {
        let cache = null;
        return id => {
            if (!cache) {
                cache = {};
                const grupos = detectarPatrones();
                for (const [idx, ids] of Object.entries(grupos)) {
                    ids.forEach(i => (cache[i] = idx));
                }
            }
            return cache[id] ?? '';
        };
    })();

    function normTxt(s) {
        return (s || '')
            .toLowerCase()
            .normalize('NFD').replace(/\p{Diacritic}/gu, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

    function variantIdsDeThumb(thumb) {
        const slideId = thumb.id.replace('Thumb-', 'Slide-');
        const slide   = document.getElementById(slideId);
        return (slide?.getAttribute('data-variant-ids') || thumb.getAttribute('data-variant-ids') || '')
            .split(',')
            .map(s => s.trim())
            .filter(Boolean);
    }

    function grupoDeThumb(thumb) {
        const ids = variantIdsDeThumb(thumb);
        if (!ids.length) return null;

        return ids.join(',');
    }

    function opcionesSeleccionadas() {
        const selected = {};

        $$('variant-selects:not([data-update-url="false"]) fieldset').forEach(fieldset => {
            const index = fieldset.dataset.index;
            if (!index || selected[index] != null) return;

            const input = fieldset.querySelector('input[type="radio"]:checked');
            const select = fieldset.querySelector('select');
            const value = input?.value || select?.value;

            if (value) selected[index] = value;
        });

        return selected;
    }

    function varianteSeleccionada() {
        const variants = leerVariantesJSON();
        const selected = opcionesSeleccionadas();
        const keys = Object.keys(selected);

        if (keys.length) {
            const exact = variants.find(v =>
                keys.every(key => normTxt(v[key]) === normTxt(selected[key]))
            );
            if (exact) return exact;
        }

        const hidden = document.querySelector('product-form form input[name="id"], form[action="/cart/add"] input[name="id"]');
        if (hidden?.value) {
            const byId = variants.find(v => String(v.id) === String(hidden.value));
            if (byId) return byId;
        }

        return null;
    }

    function detectarPatrones() {
        if (patronesCache) return patronesCache;

        const grupos = {};
        let idx = -1;
        let currentGroup = null;

        $$('#Product-Thumbnails .product-thumbnail').forEach(t => {
            const thumbGroup = grupoDeThumb(t);

            if (thumbGroup) {
                if (currentGroup === null || thumbGroup !== currentGroup) {
                    idx++;
                    currentGroup = thumbGroup;
                }
            } else if (idx === -1) {
                idx = 0;
            }

            (grupos[idx] ??= []).push(t.id);
        });

        return patronesCache = grupos;
    }

    function obtenerColorSeleccionado() {
        const inpt = document.querySelector(
            '.product-form__input--color input[type="radio"]:checked'
        );
        if (!inpt) return null;
        return {
            valor       : inpt.value,
            normalizado : inpt.value.toLowerCase().replace(/\s+/g, '-'),
            elemento    : inpt
        };
    }

    /* Mapea colores ↔ patrones */
    function asociarColoresConPatrones() {
        const patrones = detectarPatrones(),
            colores  = $$('.product-form__input--color input[type="radio"]');
        const keysPat = Object.keys(patrones).sort((a, b) => a - b); 

        if (keysPat.length === colores.length) {
            const map = {};
            colores.forEach((c, i) => {
                map[c.value.toLowerCase().replace(/\s+/g, '-')] = keysPat[i];
            });
            return map;
        }
        return {};
    }

    function obtenerPatronDeColor() {
        const col = obtenerColorSeleccionado();
        if (!col) return null;

        const grupos = detectarPatrones();
        const variants = leerVariantesJSON();
        const selectedVariant = varianteSeleccionada();
        let variantIds = selectedVariant ? [String(selectedVariant.id)] : [];

        if (!variantIds.length) {
            variantIds = variants
                .filter(v => Object.values(v).some(value => normTxt(String(value)) === normTxt(col.valor)))
                .map(v => String(v.id));
        }

        for (const [idx, thumbIds] of Object.entries(grupos)) {
            for (const thumbId of thumbIds) {
                const slide = document.getElementById(thumbId.replace('Thumb-', 'Slide-'));
                const ids = (slide?.getAttribute('data-variant-ids') || '')
                    .split(',')
                    .map(s => s.trim())
                    .filter(Boolean);
                if (ids.some(id => variantIds.includes(id))) return idx;
            }
        }

        if (selectedVariant?.option1) {
            const fallbackIds = variants
                .filter(v => normTxt(v.option1) === normTxt(selectedVariant.option1))
                .map(v => String(v.id));

            for (const [idx, thumbIds] of Object.entries(grupos)) {
                for (const thumbId of thumbIds) {
                    const thumb = document.getElementById(thumbId);
                    const ids = thumb ? variantIdsDeThumb(thumb) : [];
                    if (ids.some(id => fallbackIds.includes(id))) return idx;
                }
            }
        }

        const asociaciones = asociarColoresConPatrones();
        let pat = asociaciones[col.normalizado];
        if (pat == null) {
            const radios = $$('.product-form__input--color input[type="radio"]');
            const keys   = Object.keys(grupos).sort((a, b) => Number(a) - Number(b));
            const radioIdx = radios.findIndex(r => r === col.elemento);
            if (radioIdx > -1 && radioIdx < keys.length) pat = keys[radioIdx];
        }
        return pat;
    }

    function slideParaVarianteActual() {
        const variantId = obtenerVariantSeleccionada();
        if (!variantId) return null;

        const slide = document.querySelector(
            `.product-images__slide[data-variant-ids*="${variantId}"]`
        );
        if (slide) return slide;

        for (const sl of $$('.product-images__slide[data-variant-ids]')) {
            const ids = (sl.getAttribute('data-variant-ids') || '').split(',').map(s => s.trim());
            if (ids.includes(variantId)) return sl;
        }
        return null;
    }

    /* --- Sincronizar clases en thumbnails --- */
    function syncThumbClasses(slideEl) {
        const thumbs = $$('#Product-Thumbnails .product-thumbnail');
        thumbs.forEach(t => t.classList.remove('is-active', 'is-selected', 'is-initial-selected'));

        let active = null;
        if (slideEl) {
            active = document.getElementById(slideEl.id.replace('Slide-', 'Thumb-'));
        }
        if (!active || active.classList.contains('hide-image')) {
            active = thumbs.find(t => !t.classList.contains('hide-image'));
        }
        if (active) active.classList.add('is-active', 'is-initial-selected');
    }

    function filtrarMiniaturas() {
        const patron   = obtenerPatronDeColor();
        const patrones = detectarPatrones();
        const idsOk    = patron != null ? new Set(patrones[patron] || []) : null;

        let visibles = 0;
        $$('#Product-Thumbnails .product-thumbnail').forEach(t => {
            const show = !idsOk || idsOk.has(t.id);
            t.classList.toggle('hide-image', !show);
            if (show) visibles++;
        });
        if (visibles === 0)
            $$('#Product-Thumbnails .product-thumbnail').forEach(t => t.classList.remove('hide-image'));
    }

    function aplicarFiltro() {
        if (filtrando) return;
        filtrando = true;
        setTimeout(() => {
            patronesCache = null;
            filtrarMiniaturas();
            filtrando = false;
        }, 100);
    }

    /* ─── BLOQUE SLIDES / CARRUSEL NATIVO ─── */
    function cleanupSlides() {
        if (mutationObserver) {
            mutationObserver.disconnect();
            mutationObserver = null;
        }
        if (resizeListener) {
            window.removeEventListener('resize', resizeListener);
            resizeListener = null;
        }
        navClickListeners.forEach((listener, btn) => {
            btn.removeEventListener('click', listener, true);
        });
        navClickListeners.clear();
    }

    function initSlides() {
        cleanupSlides();
        
        const sliderContainer = document.querySelector('product-slider.flickity-enabled'),
              flickitySlider  = document.querySelector('.flickity-slider'),
              thumbsContainer = document.getElementById('Product-Thumbnails');
        if (!sliderContainer || !thumbsContainer || !flickitySlider) return;

        const flkty = window.ThemeCarousel && window.ThemeCarousel.get(sliderContainer);
        if (flkty) {
            flkty.options.cellSelector = '.product-images__slide';
            flkty.options.skipHiddenCells = true;
        }

        let slidesVisibles = [], maxX = 0, curX = 0;

        const updateThumbActiveFromSlide = idx => {
            const idSlide = slidesVisibles[idx]?.id || '';
            $$('#Product-Thumbnails .product-thumbnail').forEach(t => {
                const act = t.id.replace('Thumb-', 'Slide-') === idSlide;
                t.classList.toggle('is-active', act);
                t.classList.toggle('is-selected', act);
                t.classList.toggle('is-initial-selected', act);
            });
        };

        const reorganizarSlides = () => {
            if (reorganizando) return;
            reorganizando = true;

            const idsVisibles = $$('.product-thumbnail:not(.hide-image)', thumbsContainer)
                                .map(t => t.id.replace('Thumb-', 'Slide-'));

            slidesVisibles = idsVisibles
                .map(id => document.getElementById(id))
                .filter(Boolean);

            if (flkty) {
                flkty.options.cellSelector = '.product-images__slide';
                flkty.options.skipHiddenCells = true;
                try {
                    flkty.reloadCells();
                    flkty.resize();

                    let selected =
                        slideParaVarianteActual() ||
                        sliderContainer.querySelector('.product-images__slide.is-initial-selected:not(.hide-slide)') ||
                        sliderContainer.querySelector('.product-images__slide.is-selected:not(.hide-slide)') ||
                        slidesVisibles[0];

                    if (selected?.classList.contains('hide-slide')) {
                        selected = slidesVisibles[0];
                    }

                    if (selected) {
                        selected.classList.add('is-initial-selected', 'is-selected');
                        const cell = flkty.getCell(selected);
                        const idx = cell != null ? flkty.cells.indexOf(cell) : 0;
                        if (idx !== -1) flkty.select(idx, false, true);
                        syncThumbClasses(selected);
                    } else if (flkty.cells.length) {
                        flkty.select(0, false, true);
                        syncThumbClasses(slidesVisibles[0]);
                    }
                } catch (e) {
                    console.warn('[slider-config] Error al recargar carrusel:', e);
                } finally {
                    reorganizando = false;
                }
                return;
            }

            slidesVisibles = slidesVisibles.map((s, i) => (s.style.transform = `translateX(${i * 100}%)`, s));
            maxX = -(slidesVisibles.length - 1) * 100;

            const sel = sliderContainer.querySelector('.product-images__slide.is-selected:not(.hide-slide)');
            const idx = sel ? slidesVisibles.indexOf(sel) : 0;
            slidesVisibles.forEach((s, i) => s.classList.toggle('is-selected', i === idx));
            curX = -idx * 100;
            flickitySlider.style.transform = `translateX(${curX}%)`;

            updateThumbActiveFromSlide(idx);
            reorganizando = false;
        };

        reorganizarSlidesFn = reorganizarSlides;

        resizeListener = () => setTimeout(reorganizarSlides, 200);
        window.addEventListener('resize', resizeListener);

        mutationObserver = new MutationObserver((mutations) => {
            const hideImageChanged = mutations.some(m => {
                if (m.type !== 'attributes' || m.attributeName !== 'class') return false;
                if (!m.target.classList?.contains('product-thumbnail')) return false;
                const hadHide = m.oldValue?.includes('hide-image');
                const hasHide = m.target.classList.contains('hide-image');
                return hadHide !== hasHide;
            });
            if (hideImageChanged) reorganizarSlides();
        });
        mutationObserver.observe(thumbsContainer, {
            attributes: true,
            attributeFilter: ['class'],
            attributeOldValue: true,
            subtree: true
        });

        reorganizarSlides();
    }

   function leerVariantesJSON() {
      const el = document.querySelector('variant-selects script[type="application/json"]');
      if (!el) return [];
      try { return JSON.parse(el.textContent.trim()) || []; } catch(e) { return []; }
    }

  function obtenerVariantSeleccionada() {
    const variants = leerVariantesJSON();
    const selectedVariant = varianteSeleccionada();
    if (selectedVariant) return String(selectedVariant.id);

    const avail = variants.find(v => v.available);
    if (avail) return String(avail.id);
    const hidden = document.querySelector('product-form form input[name="id"], form[action="/cart/add"] input[name="id"]');
    if (hidden?.value) return String(hidden.value);

    return variants[0] ? String(variants[0].id) : '';
  }

  function forzarURLDeVarianteSiHaceFalta() {
    const variants = leerVariantesJSON();
    const wrap = document.querySelector('.product-form__input--color');
    const firstRadio = wrap?.querySelector('input[type="radio"]');
    const idSel = obtenerVariantSeleccionada();

    if (!wrap || !firstRadio || !idSel) return false;

    let firstId = '';
    const vFirst = variants.find(v => normTxt(v.option1) === normTxt(firstRadio.value));
    if (vFirst) firstId = String(vFirst.id);

    if (idSel === firstId) return false;

    const url = new URL(location.href);
    const actual = url.searchParams.get('variant');
    if (actual === idSel) return false;
    
    url.searchParams.set('variant', idSel);
    location.replace(url.toString());
    return true;
  }



    async function boot() {
     if (forzarURLDeVarianteSiHaceFalta()) return;
      if (location.search.includes('variant=')) {
        await reordenarThumbsSegunProducto();
    }

    aplicarFiltro();
    const colorWrap = document.querySelector('.product-form__input--color');
    colorWrap?.addEventListener('change', e => {
        if (e.target.type === 'radio') aplicarFiltro();
    });

    document.addEventListener('product:variant-change', () => {
        setTimeout(() => {
            patronesCache = null;
            filtrarMiniaturas();
            if (reorganizarSlidesFn) reorganizarSlidesFn();
        }, 250);
    });

    setTimeout(initSlides, 500);
    }

    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', boot)
        : boot();
})();